import { Routes, Route, Navigate } from 'react-router-dom';
import MarketingLayout from './components/MarketingLayout';
import PortalLayout from './pages/portal/PortalLayout';
import { ClonedPage } from './pages/marketing/ClonedPage';
import { BlogIndex, BlogPost } from './pages/marketing/BlogCloned';
import { LoginPage, RegisterPage, ForgotPasswordPage, ResetPasswordPage, VerifyOtpPage } from './pages/auth/AuthPages';
import { DashboardPage } from './pages/portal/DashboardPage';
import { OrdersPage } from './pages/portal/OrdersPage';
import { ChooseStockPage } from './pages/portal/ChooseStockPage';
import { BuyPage } from './pages/portal/BuyPage';
import { ReviewOrderPage } from './pages/portal/ReviewOrderPage';
import { StockDetailPage } from './pages/portal/StockDetailPage';
import { CollectionsPage } from './pages/portal/CollectionsPage';
import { RewardClaimPage } from './pages/portal/RewardClaimPage';
import { RewardUnlockedPage } from './pages/portal/RewardUnlockedPage';
import { AIBotPage } from './pages/portal/AIBotPage';
import { TiersPage } from './pages/portal/TiersPage';
import { ChallengeDetailPage } from './pages/portal/ChallengeDetailPage';
import { NotificationsPage } from './pages/portal/NotificationsPage';
import { WalletPage } from './pages/portal/WalletPage';
import { PlatformDetailPage } from './pages/portal/PlatformDetailPage';
import { StrategyDetailPage } from './pages/portal/StrategyDetailPage';
import { TradeHistoryPage } from './pages/portal/TradeHistoryPage';
import { NewsPage } from './pages/portal/NewsPage';
import { SettingsPage } from './pages/portal/SettingsPage';
import { AchievementsPage } from './pages/portal/AchievementsPage';
import { PayoutsSchedulePage } from './pages/portal/PayoutsSchedulePage';
import { HelpCenterPage } from './pages/portal/HelpCenterPage';
import { AnalyticsPage } from './pages/portal/AnalyticsPage';
import { GoalsPage } from './pages/portal/GoalsPage';
import { LeaderboardPage } from './pages/portal/LeaderboardPage';
import { ReferralsPage } from './pages/portal/ReferralsPage';
import { AcademyPage } from './pages/portal/AcademyPage';
import { ActivityLogPage } from './pages/portal/ActivityLogPage';
import { ApiKeysPage } from './pages/portal/ApiKeysPage';
import { MarketCalendarPage } from './pages/portal/MarketCalendarPage';
import { BrokersPage } from './pages/portal/BrokersPage';
import { SecurityPage } from './pages/portal/SecurityPage';
import { SubscriptionPage } from './pages/portal/SubscriptionPage';
import { BacktestPage } from './pages/portal/BacktestPage';
import { MorePage } from './pages/portal/MorePage';
import { KycFlowPage } from './pages/portal/KycFlowPage';
import { DepositFlowPage } from './pages/portal/DepositFlowPage';
import { WithdrawFlowPage } from './pages/portal/WithdrawFlowPage';
import { PayoutMethodsPage } from './pages/portal/PayoutMethodsPage';
import { StatementsPage } from './pages/portal/StatementsPage';
import { BotConfigPage } from './pages/portal/BotConfigPage';
import { TradeDetailPage } from './pages/portal/TradeDetailPage';
import { HelpArticlePage } from './pages/portal/HelpArticlePage';
import { SearchPage } from './pages/portal/SearchPage';
import { CountrySelectorPage } from './pages/portal/CountrySelectorPage';
import { NotificationsSettingsPage } from './pages/portal/NotificationsSettingsPage';
import { TradeJournalPage } from './pages/portal/TradeJournalPage';
import { AchievementDetailPage } from './pages/portal/AchievementDetailPage';
import { OnboardingPage } from './pages/portal/OnboardingPage';
import { BotMarketplacePage } from './pages/portal/BotMarketplacePage';
import { TraderProfilePage } from './pages/portal/TraderProfilePage';
import { SocialFeedPage } from './pages/portal/SocialFeedPage';
import { TierCheckoutPage } from './pages/portal/TierCheckoutPage';
import { ProfileEditPage } from './pages/portal/ProfileEditPage';
import { TwoFactorSetupPage } from './pages/portal/TwoFactorSetupPage';
import { PositionCalculatorPage } from './pages/portal/PositionCalculatorPage';
import { MessagesPage } from './pages/portal/MessagesPage';
import { FeedbackPage } from './pages/portal/FeedbackPage';
import { AboutPage } from './pages/portal/AboutPage';
import { NotificationDetailPage } from './pages/portal/NotificationDetailPage';
import { CourseDetailPage } from './pages/portal/CourseDetailPage';
import { ChartViewerPage } from './pages/portal/ChartViewerPage';
import { StatementPdfPage } from './pages/portal/StatementPdfPage';
import { BotDetailPage } from './pages/portal/BotDetailPage';
import { TradingRoomPage } from './pages/portal/TradingRoomPage';
import { ShowcasePage } from './pages/portal/ShowcasePage';
import { TierComparePage } from './pages/portal/TierComparePage';
import { ChallengePricingPage } from './pages/portal/ChallengePricingPage';
import { DailyPausePage } from './pages/portal/DailyPausePage';
import { ScalingPlanPage } from './pages/portal/ScalingPlanPage';
import { ResetChallengePage } from './pages/portal/ResetChallengePage';
import { CertificatesPage } from './pages/portal/CertificatesPage';
import { TradingRulesPage } from './pages/portal/TradingRulesPage';
import { AutoFlattenPage } from './pages/portal/AutoFlattenPage';
import { NewsBlackoutsPage } from './pages/portal/NewsBlackoutsPage';
import { PromotionsPage } from './pages/portal/PromotionsPage';
import { FaqCenterPage } from './pages/portal/FaqCenterPage';
import { DisclosuresPage } from './pages/portal/DisclosuresPage';
import { MarginMonitorPage } from './pages/portal/MarginMonitorPage';
import { RiskCenterPage } from './pages/portal/RiskCenterPage';
import { PaymentsHubPage } from './pages/portal/hubs/PaymentsHubPage';
import { AccountHubPage } from './pages/portal/hubs/AccountHubPage';
import { SecurityHubPage } from './pages/portal/hubs/SecurityHubPage';
import { AIHubPage } from './pages/portal/hubs/AIHubPage';
import { OrdersHubPage } from './pages/portal/hubs/OrdersHubPage';
import { RiskHubPage } from './pages/portal/hubs/RiskHubPage';
import { ChallengesHubPage } from './pages/portal/hubs/ChallengesHubPage';
import { SupportHubPage } from './pages/portal/hubs/SupportHubPage';
import { SettingsHubPage } from './pages/portal/hubs/SettingsHubPage';
import { ProductionShowcasePage } from './pages/portal/ProductionShowcasePage';
import { AdminApp } from './pages/admin/AdminApp';
import { SubscriptionsPage } from './pages/portal/SubscriptionsPage';
import { PlatformsPage } from './pages/portal/PlatformsPage';
import { EconomicCalendarPage } from './pages/portal/EconomicCalendarPage';
import { AffiliatePage } from './pages/portal/AffiliatePage';
import { HelpPage } from './pages/portal/HelpPage';
import { KYCPage } from './pages/portal/KYCPage';
import { DepositPage } from './pages/portal/PaymentPages';
import { WithdrawPage } from './pages/portal/WithdrawPage';
import { ProfilePage } from './pages/portal/ProfilePage';
import { RewardsPage } from './pages/portal/RewardsPage';
import { AuthGuard } from './pages/auth/AuthGuard';
import { NotFoundPage } from './pages/NotFoundPage';
import { ChallengePage } from './pages/portal/challenge/ChallengePage';
import { ChallengeTierPage } from './pages/portal/challenge/ChallengeTierPage';
import { ChallengeSizePage } from './pages/portal/challenge/ChallengeSizePage';
import { ChallengePlatformPage } from './pages/portal/challenge/ChallengePlatformPage';
import { ChallengeCheckoutPage } from './pages/portal/challenge/ChallengeCheckoutPage';

export default function App() {
  return (
    <Routes>
      {/* Marketing — every route renders the ACTUAL cloned HTML */}
      <Route element={<MarketingLayout />}>
        <Route path="/" element={<ClonedPage source="index.html" title="Funder Pro — Smarter Investing, Powered by AI" />} />
        <Route path="/how-it-works" element={<ClonedPage source="how-it-works.html" title="How It Works — Funder Pro" />} />
        <Route path="/about-us" element={<ClonedPage source="about-us.html" title="About Us — Funder Pro" />} />
        <Route path="/blog" element={<BlogIndex />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/contact-us" element={<ClonedPage source="contact-us.html" title="Contact Us — Funder Pro" />} />
        <Route path="/terms-conditions" element={<ClonedPage source="terms-conditions.html" title="Terms & Conditions — Funder Pro" />} />
        <Route path="/privacy-notice" element={<ClonedPage source="privacy-notice.html" title="Privacy Notice — Funder Pro" />} />
        <Route path="/cookie-notice" element={<ClonedPage source="cookie-notice.html" title="Cookies Notice — Funder Pro" />} />
        <Route path="/risk-disclosure" element={<ClonedPage source="risk-disclosure.html" title="Risk Disclosure — Funder Pro" />} />
        <Route path="/risk-disclaimer" element={<ClonedPage source="risk-disclaimer.html" title="Risk Disclaimer — Funder Pro" />} />
        <Route path="/sitemap" element={<ClonedPage source="sitemap.html" title="Sitemap — Funder Pro" />} />
        <Route path="/gold-offer" element={<ClonedPage source="gold-offer.html" title="Gold Offer — Funder Pro" />} />
        <Route path="/link-tree" element={<ClonedPage source="link-tree.html" title="Links — Funder Pro" />} />
      </Route>

      {/* Auth */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/verify-otp" element={<VerifyOtpPage />} />

      {/* Customer portal — Base44 iOS design */}
      <Route path="/portal" element={<AuthGuard><PortalLayout /></AuthGuard>}>
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="orders" element={<OrdersPage />} />
        <Route path="subscriptions" element={<SubscriptionsPage />} />
        <Route path="rewards" element={<RewardsPage />} />
        <Route path="platforms" element={<PlatformsPage />} />
        <Route path="economic-calendar" element={<EconomicCalendarPage />} />
        <Route path="affiliate" element={<AffiliatePage />} />
        <Route path="help" element={<HelpPage />} />
        <Route path="kyc" element={<KYCPage />} />
        <Route path="wallet/deposit" element={<DepositPage />} />
        <Route path="wallet/withdraw" element={<WithdrawPage />} />
        <Route path="profile" element={<ProfilePage />} />
        {/* Challenge flow — 4 steps + entry */}
        <Route path="challenge" element={<ChallengePage />} />
        <Route path="challenge/tier" element={<ChallengeTierPage />} />
        <Route path="challenge/size" element={<ChallengeSizePage />} />
        <Route path="challenge/platform" element={<ChallengePlatformPage />} />
        <Route path="challenge/checkout" element={<ChallengeCheckoutPage />} />
        {/* Trading app flow — Discover / Stocks / Buy / Review */}
        <Route path="discover" element={<ChooseStockPage />} />
        <Route path="choose-stock" element={<ChooseStockPage />} />
        <Route path="buy/:stockId" element={<BuyPage />} />
        <Route path="buy" element={<BuyPage />} />
        <Route path="review" element={<ReviewOrderPage />} />
        <Route path="stock/:stockId" element={<StockDetailPage />} />
        <Route path="stock" element={<StockDetailPage />} />
        <Route path="collections" element={<CollectionsPage />} />
        <Route path="rewards/claim" element={<RewardClaimPage />} />
        <Route path="rewards/unlocked" element={<RewardUnlockedPage />} />
        <Route path="bot" element={<AIBotPage />} />
        <Route path="tiers" element={<TiersPage />} />
        <Route path="challenge/:id" element={<ChallengeDetailPage />} />
        <Route path="challenge" element={<ChooseStockPage />} />
        <Route path="notifications" element={<NotificationsPage />} />
        <Route path="wallet" element={<WalletPage />} />
        <Route path="platform/:key" element={<PlatformDetailPage />} />
        <Route path="strategy/:key" element={<StrategyDetailPage />} />
        <Route path="trades" element={<TradeHistoryPage />} />
        <Route path="news" element={<NewsPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="achievements" element={<AchievementsPage />} />
        <Route path="payouts" element={<PayoutsSchedulePage />} />
        <Route path="help-center" element={<HelpCenterPage />} />
        <Route path="analytics" element={<AnalyticsPage />} />
        <Route path="goals" element={<GoalsPage />} />
        <Route path="leaderboard" element={<LeaderboardPage />} />
        <Route path="referrals" element={<ReferralsPage />} />
        <Route path="academy" element={<AcademyPage />} />
        <Route path="activity" element={<ActivityLogPage />} />
        <Route path="api-keys" element={<ApiKeysPage />} />
        <Route path="market-calendar" element={<MarketCalendarPage />} />
        <Route path="brokers" element={<BrokersPage />} />
        <Route path="security" element={<SecurityPage />} />
        <Route path="subscription" element={<SubscriptionPage />} />
        <Route path="backtest" element={<BacktestPage />} />
        <Route path="more" element={<MorePage />} />
        <Route path="kyc-flow" element={<KycFlowPage />} />
        <Route path="deposit-flow" element={<DepositFlowPage />} />
        <Route path="withdraw-flow" element={<WithdrawFlowPage />} />
        <Route path="payout-methods" element={<PayoutMethodsPage />} />
        <Route path="statements" element={<StatementsPage />} />
        <Route path="bot-config" element={<BotConfigPage />} />
        <Route path="trade/:id" element={<TradeDetailPage />} />
        <Route path="article/:slug" element={<HelpArticlePage />} />
        <Route path="search" element={<SearchPage />} />
        <Route path="country" element={<CountrySelectorPage />} />
        <Route path="notifications-settings" element={<NotificationsSettingsPage />} />
        <Route path="journal" element={<TradeJournalPage />} />
        <Route path="achievement/:id" element={<AchievementDetailPage />} />
        <Route path="onboarding" element={<OnboardingPage />} />
        <Route path="bot-marketplace" element={<BotMarketplacePage />} />
        <Route path="trader/:id" element={<TraderProfilePage />} />
        <Route path="feed" element={<SocialFeedPage />} />
        <Route path="tier-checkout" element={<TierCheckoutPage />} />
        <Route path="profile-edit" element={<ProfileEditPage />} />
        <Route path="2fa-setup" element={<TwoFactorSetupPage />} />
        <Route path="calculator" element={<PositionCalculatorPage />} />
        <Route path="messages" element={<MessagesPage />} />
        <Route path="messages/:id" element={<MessagesPage />} />
        <Route path="feedback" element={<FeedbackPage />} />
        <Route path="about" element={<AboutPage />} />
        <Route path="notification/:id" element={<NotificationDetailPage />} />
        <Route path="course/:id" element={<CourseDetailPage />} />
        <Route path="chart" element={<ChartViewerPage />} />
        <Route path="chart/:id" element={<ChartViewerPage />} />
        <Route path="statement-pdf" element={<StatementPdfPage />} />
        <Route path="bot-detail/:id" element={<BotDetailPage />} />
        <Route path="trading-room" element={<TradingRoomPage />} />
        <Route path="showcase" element={<ShowcasePage />} />
        <Route path="tier-compare" element={<TierComparePage />} />
        {/* v28: marketing-aligned product pages */}
        <Route path="challenge-pricing" element={<ChallengePricingPage />} />
        <Route path="daily-pause" element={<DailyPausePage />} />
        <Route path="scaling" element={<ScalingPlanPage />} />
        <Route path="reset-challenge" element={<ResetChallengePage />} />
        <Route path="reset-challenge/:id" element={<ResetChallengePage />} />
        <Route path="certificates" element={<CertificatesPage />} />
        <Route path="trading-rules" element={<TradingRulesPage />} />
        <Route path="auto-flatten" element={<AutoFlattenPage />} />
        <Route path="news-blackouts" element={<NewsBlackoutsPage />} />
        <Route path="promotions" element={<PromotionsPage />} />
        <Route path="faq-center" element={<FaqCenterPage />} />
        <Route path="disclosures" element={<DisclosuresPage />} />
        <Route path="margin" element={<MarginMonitorPage />} />
        <Route path="risk-center" element={<RiskCenterPage />} />
        {/* v29: consolidated hub pages (More-page refactor) */}
        <Route path="hub/payments"   element={<PaymentsHubPage />} />
        <Route path="hub/account"    element={<AccountHubPage />} />
        <Route path="hub/security"   element={<SecurityHubPage />} />
        <Route path="hub/ai"         element={<AIHubPage />} />
        <Route path="hub/orders"     element={<OrdersHubPage />} />
        <Route path="hub/risk"       element={<RiskHubPage />} />
        <Route path="hub/challenges" element={<ChallengesHubPage />} />
        <Route path="hub/support"    element={<SupportHubPage />} />
        <Route path="hub/settings"   element={<SettingsHubPage />} />
        <Route path="showcase/production" element={<ProductionShowcasePage />} />
      </Route>

      {/* Admin portal — completely separate system */}
      <Route path="/admin/*" element={<AdminApp />} />

      {/* Legacy routes → redirect to new portal */}
      <Route path="/admin" element={<Navigate to="/portal/dashboard" replace />} />
      <Route path="/profile" element={<Navigate to="/portal/profile" replace />} />
      <Route path="/wallet" element={<Navigate to="/portal/dashboard" replace />} />
      <Route path="/plans" element={<Navigate to="/portal/platforms" replace />} />
      <Route path="/market" element={<Navigate to="/portal/platforms" replace />} />

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
